import { filterOrganizationIdsUserCanManageBadges } from './filterOrganizationIdsUserCanManageBadges';
import { filterOrganizationIdsUserCanManageMembers } from './filterOrganizationIdsUserCanManageMembers';
export function filterBadgeOrganizationIdsUserHasPermissions(userState, organizationIdsAssignedToBadge) {
    const badgeOrgIdsCanManageMembers = filterOrganizationIdsUserCanManageMembers(userState, organizationIdsAssignedToBadge);
    const badgeOrgIdsCanManageBadges = filterOrganizationIdsUserCanManageBadges(userState, organizationIdsAssignedToBadge);
    return {
        badgeOrgIdsCanManageMembers,
        badgeOrgIdsCanManageBadges,
        badgeOrgIdsCanManageAny: [...new Set([...badgeOrgIdsCanManageMembers, ...badgeOrgIdsCanManageBadges])],
    };
}
